module.exports = __webpack_public_path__ + "static/media/ic_filter-primary.ce3c27f8.svg";